import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const Widget = (props) => {
    return (_jsx("div", { className: `card mb-3 ${props.shadow ? "shadow" : ""}`, children: props.children }));
};
export default Widget;
